import React, { Component } from 'react';
import './Difficulty.css';
import Lightbox from '../utility/Lightbox';
import User from '../../User';
import Img from '../../StableImage';

export default class Difficulty extends Component {

  state = {
    status: null,
    callback: null,
    moreInfo: false
  }

  open = (callback) => {
    this.setState({ status: "difficulty", callback });
  }

  close = () => {
    this.setState({ status: null, moreInfo: false });
  }

  changeDifficulty(difficulty) {
    if (!User.isDifficultyUnlocked(difficulty))
      return;
    if (User.getItem("difficulty") !== difficulty) {
      User.difficulty = difficulty;
      this.forceUpdate();
      if (this.state.callback) {
        this.close();
        this.state.callback();
      }
      if (this.props.onChangeDifficulty)
        this.props.onChangeDifficulty();
    }
  }

  render() {

    let difficulty = User.getItem("difficulty");
    const zenUnlocked = User.isDifficultyUnlocked("zen");

    return (
      <div className={"nav-item nav-difficulty"} style={{cursor: difficulty ? "pointer" : "inherit"}}>
        <Lightbox open={this.state.moreInfo} onClose={() => this.setState({ moreInfo: false })}>
          <div className="options-box">
            <h1 className="preview-title">Difficulty</h1>
            <div className="preview-info difficulty-preview-info">
              <h2>Switching difficulties</h2>
              <p>Progress earned on a difficulty is carried over to easier difficulties, but not to harder ones.</p>
              <h3>Carried over to easier difficulties</h3>
              <ul>
                <li>Shard gain</li>
                <li>Exp offered to celestials during runs</li>
                <li>Story progress and character growth</li>
              </ul>
              <h3>Not carried over</h3>
              <ul>
                <li>Shards offered to celestials from the Pantheon</li>
                <li>Selected celestial devotion ranks</li>
                <li>Run statistics and run history</li>
              </ul>
            </div>
            <div className="preview-info difficulty-preview-info">
              <h2>Milestones</h2>
              <p>Global milestones can be unlocked on any difficulty with any character.</p>
              <p>Character milestones unlock rewards for that character. Their artwork depends on the difficulty: Zen does not unlock artwork, Casual unlocks one picture, and Challenge unlocks the Casual picture plus an additional one.</p>
            </div>
          </div>
        </Lightbox>
        <Lightbox className="small options-lightbox" open={this.state.status === "difficulty" && !this.state.moreInfo} onClose={() => this.setState({ status: null })}>
          <div className="options-box">
            <h1>Difficulty</h1>
            <div className="options-info difficulty-info">
              Progression will get carried over to lower difficulty settings. You can change difficulty at any point between runs. Complete milestones with harder difficulty settings to unlock extra pictures.
              <button className="difficulty-more-info-button" type="button" aria-label="More information about difficulty" onClick={() => this.setState({ moreInfo: true })}>i</button>
            </div>
            { zenUnlocked && <div className={"difficulty-setting zen-setting " + (difficulty === "zen" ? "difficulty-selected" : "")} onClick={() => this.changeDifficulty("zen")}>
              <div className="difficulty-setting-filter"/>
              <Img className="difficulty-setting-icon" src='/images/zen.png'/>
              <div className="difficulty-setting-main">
                <div className="difficulty-setting-name">Zen</div>
                <div className="difficulty-setting-description">Enjoy a story with little challenge. Easier enemies and unlimited continues.</div>
              </div>
            </div> }
            <div className={"difficulty-setting casual-setting " + (difficulty === "casual" ? "difficulty-selected" : "")} onClick={() => this.changeDifficulty("casual")}>
              <div className="difficulty-setting-filter"/>
              <Img className="difficulty-setting-icon" src='/images/casual.png'/>
              <div className="difficulty-setting-main">
                <div className="difficulty-setting-name">Casual</div>
                <div className="difficulty-setting-description">Forgiving but engaging experience. Easier enemies.</div>
              </div>
            </div>
            <div className={"difficulty-setting challenge-setting " + (difficulty === "challenge" ? "difficulty-selected" : "")} onClick={() => this.changeDifficulty("challenge")}>
              <div className="difficulty-setting-filter"/>
              <Img className="difficulty-setting-icon" src='/images/challenge.png'/>
              <div className="difficulty-setting-main">
                <div className="difficulty-setting-name">Challenge</div>
                <div className="difficulty-setting-description">Intended difficulty for experienced players. Harder enemies.</div>
              </div>
            </div>
            {/*<div className={"difficulty-setting hardcore-setting " + (difficulty === "hardcore" ? "difficulty-selected" : "")} onClick={() => this.changeDifficulty("hardcore")}>
              <div className="difficulty-setting-filter"/>
              <Img className="difficulty-setting-icon" src='/images/hardcore.png'/>
              <div className="difficulty-setting-main">
                <div className="difficulty-setting-name">Hardcore</div>
                <div className="difficulty-setting-description">Is the game too easy for you? Unforgiving enemies.</div>
              </div>
            </div>*/}
          </div>
        </Lightbox>
        {difficulty && <div onClick={() => this.open()} className="difficulty-icon">
          <Img src={'/images/' + difficulty + '.png'}/>
        </div> }
      </div>
    );
  }
}
